var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.04 6.313a1.147 1.147 0 0 1 1.66.09 1.257 1.257 0 0 1-.09 1.725l-8.27 7.742a.503.503 0 0 1-.674 0L1.39 8.13a1.256 1.256 0 0 1-.09-1.724 1.145 1.145 0 0 1 1.66-.09c.585.547 7.032 6.595 7.032 6.595l7.05-6.597z"
  })));
};

export default SvgIconChevronDown;